import React, { useState } from 'react';
import { Button, Dropdown, Modal } from 'react-bootstrap';
import { FaEllipsisV } from 'react-icons/fa';

export default function DeleteReviewButton({ reviewId, onDelete }) {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDelete = async () => {
    setIsDeleting(true);
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`/api/reviews/${reviewId}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (response.ok) {
        onDelete(reviewId);
        setShowDeleteModal(false);
      } else {
        const errorData = await response.json();
        alert(errorData.message || 'Failed to delete review');
      }
    } catch (err) {
      console.error('Error deleting review:', err);
      alert('Failed to delete review. Please try again.');
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <>
      <Dropdown align="end">
        <Dropdown.Toggle 
          variant="light" 
          size="sm"
          style={{ 
            border: 'none', 
            padding: '4px 8px',
            backgroundColor: 'transparent'
          }}
        >
          <FaEllipsisV size={12} />
        </Dropdown.Toggle>

        <Dropdown.Menu>
          <Dropdown.Item 
            onClick={() => setShowDeleteModal(true)}
            className="text-danger"
          >
            Delete
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>

      {/* Delete Confirmation Modal */}
      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Delete Review</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete this review? This action cannot be undone.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
            Cancel
          </Button>
          <Button 
            variant="danger" 
            onClick={handleDelete}
            disabled={isDeleting}
          >
            {isDeleting ? 'Deleting...' : 'Delete'}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
} 